<template>
  <v-app>
    <v-navigation-drawer
      v-if="signInDrawer"
      v-model="drawer"
      dark
      persistent
      clipped
      enable-resize-watcher
      fixed
      app
    >
      <v-list>
        <template v-for="item in items">
          <template v-if="item.children">
            <v-list-group :key="item.title" no-action>
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>{{ item.title }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                v-for="subItem in item.items"
                :key="subItem.title"
                :to="subItem.route"
                active-class="throwy-active-item"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </template>
          <template v-else>
            <v-list-tile :key="item.title" :to="item.route" active-class="throwy-active-item">
              <v-list-tile-action>
                <v-icon>{{ item.action }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>{{ item.title }}</v-list-tile-content>
            </v-list-tile>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar dark app :clipped-left="true">
      <v-toolbar-side-icon v-if="signInDrawer" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-text="appTitle"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="$route.name != 'SignIn'">
        <v-btn flat>{{ currentUser }}</v-btn>
        <v-btn icon v-on:click="signOut">
          <v-icon>power_settings_new</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content light>
      <router-view />
    </v-content>
    <v-footer dark fixed app>
      <span>&copy; {{ this.currentYear }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import * as firebase from "firebase/app";

export default {
  data() {
    return {
      drawer: true,
      items: [
        {
          action: "phone_android",
          title: "App Content",
          route: "/AppContent",
          children: false
        },
        // {
        //   action: "people",
        //   title: "Students",
        //   route: "",
        //   children: true,
        //   items: [
        //     {
        //       title: "Summary",
        //       route: "/Students/Summary"
        //     },
        //     {
        //       title: "Create Student",
        //       route: "/Students/CreateStudent"
        //     }
        //   ]
        // },
        // {
        //   action: "perm_contact_calendar",
        //   title: "Attendance",
        //   route: "/Attendance",
        //   children: false
        // },
        // {
        //   action: "settings",
        //   title: "Admin",
        //   route: "",
        //   children: true,
        //   items: [
        //     {
        //       title: "Users",
        //       route: "/Admin/Users"
        //     }
        //   ]
        // }
      ]
    };
  },
  computed: {
    appTitle() {
      return this.$store.state.appTitle;
    },
    currentUser() {
      if (this.$store.state.auth.currentUser) {
        return this.$store.state.auth.currentUser.email;
      }
    },
    signInDrawer() {
      return this.$route.name != "SignIn";
    },
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    signOut: function() {
      this.$confirm("Are you sure you want to log out?").then(res => {
        if (res) {
          this.$store.dispatch("logout").then(() => {
            this.$router.replace("SignIn");
          });
        }
      });
    }
  },
  name: "App"
};
</script>

<style>
</style>